<template>
    <div>
        <ul>
            <li style="margin-bottom: 10px;"> <el-input size="small" v-model="changePasswordForm.password" type="password"  placeholder="请输入新密码"></el-input>
            </li>
            <li> <el-input size="small" v-model="changePasswordForm.password2" type="password"   placeholder="请重复密码"></el-input>
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        name: "Dialogs_ChangePassword",
        data() {
            return {
                changePasswordForm:{
                    password:'',
                    password2:'',
                },
            }
        },
    }
</script>

<style scoped>

</style>